export default __webpack_public_path__ + "static/media/selfSelected.6bf8df96.png";